<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">ユーザー一覧</li>
            </ol>
        </nav>
        <div>
            <div class="sticky">
                <page :last_page="users.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div class="row d-flex justify-content-center mt-3">
                <div class="col-md-8">
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-secondary btn-sm" @click="load()">
                                    <i class="fas fa-sync-alt"></i>
                                    再読み込み
                                </button>
                                <span class="input-group-text">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                            <input type="search" class="form-control" v-model="keywords"
                                placeholder="ユーザ名、メールアドレス、サブドメイン" @keydown.enter="find" />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <user-card v-for="u in users.data"
                    :user="u"
                    :page="page"
                    :key="u.id">
                </user-card>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<script>
import page from "components/Page";
import userCard from "./userCard";
export default {
    components: {
        page,
        userCard,
    },
    data() {
        return {
            users: {},
            page: parseInt(this.$route.query.page) || 1,
            keywords: this.$route.query.keywords || "",
            isLoading: false,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load()});
        },
        find(ev = null) {
            if (ev && ev.keyCode !== 13) return;
            this.page = 1;
            setTimeout(() => {this.load()});
        },
        load() {
            this.$router.push({
                path: "/admin/users",
                query: {
                    page: this.page,
                    keywords: this.keywords
                }
            }).catch(err => {});
            this.isLoading = true;
            axios.get("/admin/users/get", {params: {page: this.page, keywords: this.keywords}}).then(res => {
                this.users = res.data;
                this.isLoading = false;
            }).catch(err => { alert.err(err.response);this.isLoading = false; });
        },
        authorUrl(u) {
            return "//" + u.subdomain + this.$store.state.base_domain;
        },
        isOver(curr, max) {
            if (max <= curr) {
                return true;
            }
            return false;
        },
        isWarn(curr, max) {
            if ((max * 0.9) <= curr) {
                return true;
            }
            return false;
        },
        forPortalBackgrounds(backgrounds) {
            const bg = _.filter(backgrounds, {for_portal: 1});
            if (!bg) {
                return 0;
            }
            return bg.length;
        },
        forBookshelfBackgrounds(backgrounds) {
            const bg = _.filter(backgrounds, {for_portal: 0, book_id: null, section_id: null});
            if (!bg) {
                return 0;
            }
            return bg.length;
        },
        forBookBackgrounds(backgrounds) {
            const bg = _.filter(backgrounds, (o) => { return o.book_id; });
            if (!bg) {
                return 0;
            }
            return bg.length;
        },
        forEpisodeBackgrounds(backgrounds) {
            const bg = _.filter(backgrounds, (o) => { return o.section_id; });
            if (!bg) {
                return 0;
            }
            return bg.length;
        },
    },
    watch: {
        keywords(n, o) {
            if (o.length > 0 && n.length === 0) {
                this.load();
            }
        }
    },
    mounted() {
        this.load();
    }
}
</script>